import React, { Component } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  ButtonGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import { connect } from "react-redux";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";

import moment from "moment";
import SimpleBar from "simplebar-react";
import {
  getPurchaseOrderList,
  SetParams,
  toggleItemMenu,
  listlayout,
  getPDFDownload,
  PurchaseOrderClose,
  PoFoucsPost,
  POClose_modal_open,
  POClose_modal_close,
  viewLogShowRightSidebarPurchase,
  ToggleEdit,
  GetWoAuthorizationStatus,
} from "../../store/SRPurchaseOrder/actions";
import Defaultuser from "../../assets/images/users/Default_User.png";
import LoadingModel from "../LoadingModel";
import swal from "sweetalert";
import POcloseModel from "./PurchaseOrderTask/POclose_model";

class AllPurchaseOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPOId: null, // State to store the selected PO ID
    };
  }
  onSortChange = () => {
    var sort = ["code", "createdon"];
    var currentSort = this.props.params.currentSort;
    var i = sort.indexOf(currentSort);
    if (i !== -1 && i + 1 < sort.length) {
      currentSort = sort[i + 1];
    } else {
      currentSort = sort[0];
    }
    this.props.SetParams({
      ...this.props.params,
      currentSort: currentSort,
    });
    this.props.getPurchaseOrderList({
      ...this.props.params,
      currentSort: currentSort,
    });
  };
  onSortOrderChange = () => {
    // var sort = ["", "-"];
    var sortOrder = this.props.params.sortOrder;
    if (sortOrder === "") {
      sortOrder = "-";
    } else {
      sortOrder = "";
    }

    this.props.SetParams({ ...this.props.params, sortOrder: sortOrder });
    this.props.getPurchaseOrderList({
      ...this.props.params,
      sortOrder: sortOrder,
    });
  };
  onlayoutChange = () => {
    var layout = this.props.layout;
    if (layout === "list") {
      layout = "table";
    } else {
      layout = "list";
    }
    this.props.listlayout(layout);
  };
  autohandleSearch = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getPurchaseOrderList(
        {
          ...this.props.params,
          search: "",
          page: 1,
        },
        true,
      );
    }
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {
      this.props.getPurchaseOrderList({
        ...this.props.params,
        page: 1,
        search: e.target.value,
      });
    }
  };

  handleCloseButton = (id) => {
    this.props.POClose_modal_open();
    this.setState({ selectedPOId: id });
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getPurchaseOrderList({ ...this.props.params, page: pageNo });
  }
  getPDF(id) {
    this.props.getPDFDownload(id);
  }

  componentDidUpdate(){
	console.log("[AllPurchaseOrder] Updated Props:", this.props.POList);
  }

  // poClose = (id) => {
  //   swal({
  //     title: "Are you sure?",
  //     text: "Once Close, you will not be able to recover this imaginary file!",
  //     icon: "warning",
  //     content: {
  //       element: "div",
  //       attributes: {
  //         innerHTML: '<textarea id="closeReason" placeholder="Enter reason for closing" rows="4" cols="50" required></textarea>'
  //       },
  //     },
  //     buttons: true,
  //     dangerMode: true,
  //   }).then((willDelete) => {
  //     if (willDelete) {
  //       const description = {description: document.getElementById('closeReason').value}
  //       if (description.description.trim() === "") {
  //         swal("Error", "Reason for closing is required!", "error");
  //       } else {
  //         this.props.PurchaseOrderClose(id, description); // Pass the reason to the action if needed
  //         swal("Success", "Your imaginary file has been closed!", "success");
  //       }
  //     } else {
  //       swal({ title: "Your imaginary file is safe!", timer: 1500 });
  //     }
  //   });
  // }

  // poClose = (id) => {
  //   console.log("id...",id)
  //   return(
  //     <>
  //     <Modal
  //         isOpen={this.props.POClose_Model}
  //         backdrop="static"
  //         centered
  //         size="lg"
  //       >

  //         <ModalBody>
  //           {/* <AvForm
  //             className="form-horizontal"
  //             onValidSubmit={() => this.handleValidSubmit()}
  //             ref={(c) => (this.addForm = c)}
  //           > */}
  //             <FormGroup className="mb-0">
  //               <Label htmlFor="Remarks" className="col-form-label ">
  //                 Acknowledge:
  //               </Label>
  //               <AvField
  //                 name="description"
  //                 id="description"
  //                 type="textarea"
  //                 className="form-control"
  //                 placeholder="Enter Description"
  //                 // value={
  //                 //   this.props.POIacknowledgeData.description == null
  //                 //     ? ""
  //                 //     : this.props.POIacknowledgeData.description
  //                 // }
  //                 // rows="7"
  //                 validate={{
  //                   required: { value: true },
  //                 }}
  //                 // onChange={this.ChangeHandeler}
  //               />
  //             </FormGroup>
  //             <div className="float-right">
  //               <Button
  //                 type="reset"
  //                 color="light"
  //                 className="waves-effect waves-light mr-2"
  //                 onClick={() => this.props.POClose_modal_close()}
  //               >
  //                 Cancel
  //               </Button>
  //               <Button
  //                 type="sudmit"
  //                 color="primary"
  //                 className="waves-effect waves-light mr-2"
  //                 onClick={() => {
  //                   this.PurchaseOrderRowData(this.props.poVendData);
  //                 }}
  //               >
  //                 Submit
  //               </Button>
  //             </div>
  //           {/* </AvForm> */}
  //         </ModalBody>
  //       </Modal>

  //     </>
  //   )
  // }

  focusPost = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once Close, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.props.PoFoucsPost(id);
      } else {
        swal({ title: "Your imaginary file is safe!", timer: 1500 });
      }
    });
  };
  viewLog(id) {
    this.props.viewLogShowRightSidebarPurchase(id);
  }
  EditPO(id) {
    this.props.viewLogShowRightSidebarPurchase(id);
  }

  handleToggle = (po) => {
    this.setState((prevState) => {
      const toggledRows = prevState.toggledRows || {};
      const prevValue = toggledRows[po.id] || false;
      const nextValue = !prevValue;

      const status = nextValue ? 2 : 3;

      const data = {
        poId: po.id,
        code: po.code,
        printapproval_status: status,
      };

      this.props.GetWoAuthorizationStatus(data);

      return {
        toggledRows: {
          ...toggledRows,
          [po.id]: nextValue,
        },
      };
    });
  };

  render() {
    return (
      <React.Fragment>
        {this.props.loading && <LoadingModel OpenModel={this.props.loading} />}

        <div className="mt-2 ">
          <div>
            <Row>
              <Col md={3}>
                <AvForm className="p-1">
                  <FormGroup className="m-0">
                    <InputGroup>
                      <Input
                        type="text"
                        name="search"
                        className="form-control d-inline-block"
                        placeholder="Search"
                        validate={{ required: true }}
                        onChange={(e) => this.autohandleSearch(e)}
                        onKeyDown={(e) => this.handleSearch(e)}
                      />
                      <InputGroupAddon addonType="append">
                        <Button
                          color="light"
                          type="submit"
                          onClick={() =>
                            this.props.getPurchaseOrderList({
                              ...this.props.params,
                              page: 1,
                            })
                          }
                        >
                          <i className="ri-search-line"></i>
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </AvForm>
              </Col>
              <Col md={9}>
                <div className="float-right p-1">
                  <div className="d-inline-block">
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem disabled={this.props.params.page <= 1}>
                        <PaginationLink
                          onClick={(e) => this.openPage(1)}
                          previous
                          // href="#"
                        />
                      </PaginationItem>

                      {this.props.params.page > 2 && (
                        <PaginationItem disabled={this.props.params.page <= 2}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page > 1 && (
                        <PaginationItem disabled={this.props.params.page === 1}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}

                      <PaginationItem active={true}>
                        <PaginationLink
                          onClick={() => this.openPage(this.props.params.page)}
                          // href="#"
                        >
                          {this.props.params.page}
                        </PaginationLink>
                      </PaginationItem>
                      {this.props.params.page + 1 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 1 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 2 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 2 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 3 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 3 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 3 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 3)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 3}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                      {this.props.params.page + 4 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 2 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 4 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 4)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 4}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                      <PaginationItem
                        disabled={
                          this.props.params.no_of_pages ===
                          this.props.params.page
                        }
                      >
                        <PaginationLink
                          onClick={(e) =>
                            this.openPage(this.props.params.no_of_pages)
                          }
                          next
                          // href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                  <ButtonGroup className="waves-effect waves-light d-inline-block ml-2 mr-2">
                    <Button color="light" onClick={this.onSortOrderChange}>
                      {this.props.params.sortOrder === "" && (
                        <i className="mdi mdi-sort-ascending mr-1"></i>
                      )}
                      {this.props.params.sortOrder === "-" && (
                        <i className="mdi mdi-sort-descending mr-1"></i>
                      )}
                    </Button>
                    <Button color="light" onClick={this.onSortChange}>
                      {this.props.Sortvar[this.props.params.currentSort]}
                    </Button>
                  </ButtonGroup>
                  <Button color="light" onClick={this.onlayoutChange}>
                    {this.props.layout === "list" && (
                      <i className="mdi mdi-table-large"></i>
                    )}
                    {this.props.layout === "table" && (
                      <i className="mdi mdi-format-list-bulleted"></i>
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          <SimpleBar style={{ maxHeight: "100%" }}>
            <Card className="p-0">
              {this.props.layout === "table" && (
                <CardBody className="p-2 ">
                  <div className="table-responsive m-0">
                    <Table bordered hover className="mb-0 p-0 table-centered">
                      <thead className="bg-light text-center">
                        <tr>
                          <th className="nowrap">SR Code</th>
                          <th className="nowrap">No.of Items</th>
                          <th className="nowrap">Quotation Date</th>
                          <th className="nowrap">SRFQ No</th>
                          <th className="nowrap">SRFQ Date</th>
                          <th className="nowrap">Gross Value</th>
                          <th className="nowrap">Fsync Status</th>
                          <th className="nowrap">Action</th>
                        </tr>
                      </thead>
                      <tbody className="nowrap">
                        {this.props.POListCount !== 0 ? (
                          <>
                            {this.props.POList?.map((po, key) => (
                              <tr key={key} className="text-center">
                                <td>
                                  <Link to={`/SrPurchaseOrder/${po.id}`}>
                                    <Button
                                      type="button"
                                      color="success"
                                      className="waves-effect waves-light orderlist_but m-2 p-1 mb-2"
                                    >
                                      <i className="mdi mdi-file-document mr-1"></i>
                                      {po.code}
                                    </Button>
                                  </Link>
                                </td>
                                <td>
                                  <Link
                                    to="#"
                                    className="m-0"
                                    // onClick={() =>
                                    //   this.props.modelListOpen(po.id)
                                    // }
                                  >
                                    {po.items_count} Items
                                  </Link>
                                </td>
                                <td>
                                  {moment(po.createdon).format("DD-MM-YYYY")}
                                </td>

                                <td>{po.servicerequestforquotation_code}</td>
                                <td>
                                  {moment(
                                    po.servicerequestforquotation_date,
                                  ).format("DD-MM-YYYY")}
                                </td>
                                <td>{po.total}</td>
                                <td>
                                  {po.erp_code && po.erp_id ? (
                                    <p>Success</p>
                                  ) : (
                                    <Button
                                      outline
                                      size="sm"
                                      type="button"
                                      color="info"
                                      className="waves-effect waves-light mr-2"
                                      onClick={() => this.focusPost(po.id)}
                                    >
                                      <i className="mdi mdi-sync"></i>
                                    </Button>
                                  )}
                                </td>
                                <td>
                                  {(po.postatus === 1 ||
                                    po.postatus === 2 ||
                                    po.postatus === 4) && (
                                    <Button
                                      outline
                                      size="sm"
                                      type="button"
                                      color="info"
                                      className="waves-effect waves-light mr-2"
                                      onClick={() =>
                                        this.handleCloseButton(po.id)
                                      }
                                    >
                                      <i className="mdi mdi-close"></i>
                                    </Button>
                                  )}
                                  {this.props.userAccessList.indexOf(
                                    "WorkOrder.change_workorderitem",
                                  ) != -1 &&
                                    (po.postatus === 1 ||
                                      po.postatus === 2) && (
                                      <Link
                                        to={`/PurchaseOrderupdate/${po.id}`}
                                      >
                                        <Button
                                          outline
                                          size="sm"
                                          type="button"
                                          color="info"
                                          className="waves-effect waves-light mr-2"
                                        >
                                          <i className="mdi mdi-pencil"></i>
                                        </Button>
                                      </Link>
                                    )}
                                  <Button
                                    outline
                                    size="sm"
                                    type="button"
                                    color="info"
                                    className="waves-effect waves-light mr-2"
                                    onClick={() => this.viewLog(po.id)}
                                  >
                                    <i className="mdi mdi-eye"></i>
                                  </Button>
                                </td>

                                {/* <td>
                                  <Button
                                    outline
                                    size="sm"
                                    type="button"
                                    color="primary"
                                    className="waves-effect waves-light mr-2"
                                    onClick={() => this.getPDF(po.id)}
                                  >
                                    <i className="mdi mdi mdi-arrow-down-bold-circle-outline icon-large "></i>
                                  </Button>
                                </td> */}
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colspan="7" className="text-center">
                              <span className="font-size-18 text-danger">
                                Data not available
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              )}
              {this.props.layout === "list" && (
                <CardBody className="p-2 ">
                  {this.props.POListCount !== 0 ? (
                    <>
                      {this.props.POList.map((po) => (
                        <div className="bg_color p-0 mb-1" key={po.id}>
                          <div className="float-right ml-3">
                            <Dropdown
                              isOpen={po.actionMenu}
                              toggle={() => this.props.toggleItemMenu(po.id)}
                            >
                              <DropdownToggle caret color="light" size="sm">
                                <i className="ri-more-line "></i>
                              </DropdownToggle>
                              <DropdownMenu right>
                                {/* <DropdownItem
                                  href="#"
                                  onClick={() => this.getPDF(Material.id)}
                                >
                                  PDF Download
                                </DropdownItem> */}
                                {!this.state.isMobile && (
                                  <DropdownItem
                                    onClick={() => this.viewLog(po.id)}
                                  >
                                    View log
                                  </DropdownItem>
                                )}

                                {this.props.userAccessList.indexOf(
                                  "WorkOrder.change_workorderitem",
                                ) != -1 &&
                                  (po.postatus == 1 || po.postatus == 2) && (
                                    <Link to={`/PurchaseOrderupdate/${po.id}`}>
                                      <DropdownItem
                                      // onClick={() =>
                                      // 	this.props.ToggleEdit(
                                      // 		item.id
                                      // 	)
                                      // }
                                      >
                                        Edit PO
                                      </DropdownItem>
                                    </Link>
                                  )}
                              </DropdownMenu>
                            </Dropdown>{" "}
                          </div>
                          <Row className="justify-content-center">
                            <Col xs={12} sm={12} md={3} lg={3} xl={2}>
                              <div className="detiles p-2 ">
                                <Link to={`/SrPurchaseOrder/${po.id}`}>
                                  <Button
                                    type="button"
                                    color="success"
                                    className="waves-effect waves-light  p-1 mb-2"
                                  >
                                    <i className="mdi mdi-file-document mr-1"></i>
                                    {po.code}
                                  </Button>
                                </Link>
                                <p className="items_title m-2">
                                  List Items:{" "}
                                  <span className="item_title_Detiles">
                                    {po.items_count}
                                  </span>
                                </p>
                                {/* <Link to="#" className="m-0">
                            <i className="mdi mdi-plus"></i>
                            More Details
                          </Link> */}
                              </div>
                            </Col>

                            <Col
                              xs={12}
                              sm={12}
                              md={9}
                              lg={9}
                              xl={10}
                              className="pb-0 mb-0"
                            >
                              <div className="Quotation_body">
                                {/* <div className="float-right ml-3">
                                  <ButtonGroup>
                                    <Dropdown
                                      isOpen={po.actionMenu}
                                      toggle={() =>
                                        this.props.toggleItemMenu(po.id)
                                      }
                                    >
                                      <DropdownToggle
                                        caret
                                        color="light"
                                        size="sm"
                                      >
                                        <i className="ri-more-line "></i>
                                      </DropdownToggle>
                                      <DropdownMenu right>
                                        <DropdownItem
                                          href="#"
                                          onClick={() => this.getPDF(po.id)}
                                        >
                                          PDF Download
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </Dropdown>{" "}
                                  </ButtonGroup>
                                </div> */}

                                <Row className="p-0 mb-0">
                                  <Col
                                    xs={12}
                                    sm={12}
                                    md={8}
                                    lg={8}
                                    xl={8}
                                    className="p-0"
                                  >
                                    <div className="panel-content">
                                      <div className="list-column row">
                                        <div className="list-data col-xl-6">
                                          <span className="ttl">
                                            Quotation Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(po.createdon).format(
                                              "DD-MM-YYYY",
                                            )}
                                          </span>
                                        </div>

                                        <div className="list-data col-xl-6">
                                          <span className="ttl"> RFQ No:</span>
                                          <span className="dtl">
                                            {po.servicerequestforquotation_code}
                                          </span>
                                        </div>

                                        <div className="list-data col-xl-6">
                                          <span className="ttl">
                                            {" "}
                                            Gross Value:
                                          </span>
                                          <span className="dtl">
                                            {po.total}
                                          </span>
                                        </div>

                                        <div className="list-data col-xl-6">
                                          <span className="ttl">RFQ Date:</span>
                                          <span className="dtl">
                                            {console.log(
                                              "[AllPurchaseOrder] SRFQ Date:",
                                              po.servicerequestforquotation_date,
                                            )}
                                            {moment(
                                              po.servicerequestforquotation_date,
                                              "YYYY-MM-DDTHH:mm:ss.SSSSSSZZ",
                                            ).isValid()
                                              ? moment(
                                                  po.servicerequestforquotation_date,
                                                ).format("DD-MM-YYYY")
                                              : "Invalid date"}
                                          </span>
                                        </div>

                                        <div className="list-data col-xl-12">
                                          <span className="ttl">
                                            {" "}
                                            Vendor Name:
                                          </span>
                                          <span className="dtl">
                                            {po.vendor?.name}
                                          </span>
                                        </div>

                                        <div className="list-data col-xl-6">
                                          <span className="ttl">
                                            {" "}
                                            Location:
                                          </span>
                                          <span className="dtl">
                                            {po.location?.name}
                                          </span>
                                        </div>

                                        <div className="list-data col-xl-6">
                                          <span className="ttl"> Status:</span>
                                          <span className="dtl">
                                            {po.woauditstatus_name}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                  {/* <Col md={4} className="pb-0 mb-0 mt-4">
																		<div className="float-right">
																			<div className="Quotation-user-content-box pr-4">
																			</div>
																			{this.props.userAccessList.indexOf(
																				"WorkOrder.can_approve_wo_print"
																			) !=
																				-1 && (
																					// <Button
																					// 	outline
																					// 	size="sm"
																					// 	type="button"
																					// 	color={this.state.isToggled ? "success" : "danger"}
																					// 	className="waves-effect waves-light mb-2"

																					// 	onClick={() => {
																					// 		const nextState = !this.state.isToggled;
																					// 		this.setState({ isToggled: nextState });


																					// 		const status = nextState ? 2 : 3;

																					// 		const data = {
																					// 			poId: po.id,
																					// 			code: po.code,
																					// 			printapproval_status: status,
																					// 		};
																					// 		this.props.GetWoAuthorizationStatus(data);
																					// 	}}
																					// >
																					// 	{this.state.isToggled ? "Approve" : "Reject"}
																					// </Button>
																					<Button
																						outline
																						size="sm"
																						type="button"
																						color={this.state.toggledRows?.[po.id] ? "danger" : "success"}
																						className="waves-effect waves-light mb-2"
																						onClick={() => this.handleToggle(po)}
																					>
																						{this.state.toggledRows?.[po.id] ? "Reject" : "Approve"}
																					</Button>
																				)}
																		</div>
																	</Col> */}

                                  <Col md={4} className="pb-0 mb-0 mt-4">
                                    <div className="float-right">
                                      <div className="Quotation-user-content-box pr-4"></div>

                                      {this.props.userAccessList.indexOf(
                                        "WorkOrder.can_approve_wo_print",
                                      ) !== -1 && (
                                        <>
                                          {po.printapproval_status === 2 ? (
                                            <Button
                                              contained
                                              size="sm"
                                              type="button"
                                              color="success"
                                              className="waves-effect waves-light mb-2 mr-2"
                                              disabled={
                                                po.printapproval_status === 2
                                              } // already approved
                                              onClick={() => {
                                                const data = {
                                                  poId: po.id,
                                                  code: po.code,
                                                  printapproval_status: 2,
                                                };
                                                this.props.GetWoAuthorizationStatus(
                                                  data,
                                                );
                                              }}
                                            >
                                              Approved
                                            </Button>
                                          ) : (
                                            <>
                                              <Button
                                                contained
                                                size="sm"
                                                type="button"
                                                color="success"
                                                className="waves-effect waves-light mb-2 mr-2"
                                                disabled={
                                                  po.printapproval_status === 2
                                                } // already approved
                                                onClick={() => {
                                                  const data = {
                                                    poId: po.id,
                                                    code: po.code,
                                                    printapproval_status: 2,
                                                  };
                                                  this.props.GetWoAuthorizationStatus(
                                                    data,
                                                  );
                                                }}
                                              >
                                                Approve
                                              </Button>

                                              {/* Reject Button */}
                                              <Button
                                                contained
                                                size="sm"
                                                type="button"
                                                color="danger"
                                                className="waves-effect waves-light mb-2"
                                                disabled={
                                                  po.printapproval_status === 2
                                                }
                                                onClick={() => {
                                                  const data = {
                                                    poId: po.id,
                                                    code: po.code,
                                                    printapproval_status: 3,
                                                  };
                                                  this.props.GetWoAuthorizationStatus(
                                                    data,
                                                  );
                                                }}
                                              >
                                                Reject
                                              </Button>
                                            </>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </Col>

                                  <Col md={4} className="pb-0 mb-0 mt-4 ">
                                    <div className="float-right">
                                      <div className="Quotation-user-content-box pr-4">
                                        <ul className="user-column d-inline-block p-0 mb-2">
                                          <li className="clearfix p-0 m-0">
                                            <span className="img">
                                              <img
                                                className="img-fluid p-0"
                                                src={
                                                  po.createdby.Image == null
                                                    ? Defaultuser
                                                    : po.createdby.Image
                                                }
                                                alt="user"
                                              />
                                            </span>
                                            <span className="ttl">
                                              {po.createdby.fullname}
                                            </span>
                                          </li>
                                          {/* <Button onClick={() => this.viewLog(po.id)}>Click me</Button> */}
                                          {/* <Button
																						outline
																						size="sm"
																						type="button"
																						color="info"
																						className="waves-effect waves-light mr-2"
																						onClick={() =>
																							this.viewLog(
																								po.id
																							)
																						}>
																						<i className="mdi mdi-eye"></i>
																					</Button> */}
                                        </ul>
                                      </div>

                                      {this.props.userAccessList.indexOf(
                                        "WorkOrder.can_close_po",
                                      ) != -1 &&
                                        (po.postatus === 1 ||
                                          po.postatus === 2 ||
                                          po.postatus === 4) && (
                                          <Button
                                            outline
                                            size="sm"
                                            type="button"
                                            color="danger"
                                            className="waves-effect waves-light mb-2"
                                            onClick={() =>
                                              this.handleCloseButton(po.id)
                                            }
                                          >
                                            <i class="mdi mdi-close icon-large "></i>{" "}
                                            Close
                                          </Button>
                                        )}
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="text-center">
                      <span className="font-size-24 text-danger">
                        Data not available{" "}
                      </span>
                    </div>
                  )}
                </CardBody>
              )}
            </Card>
          </SimpleBar>

          {this.props.POClose_Model && (
            <POcloseModel id={this.state.selectedPOId} />
          )}
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const {
    POListCount,
    POList,
    params,
    Sortvar,
    layout,
    loading,
    POClose_Model,
  } = state.SRPurchaseOrder;
  return {
    POListCount,
    POList,
    params,
    Sortvar,
    layout,
    loading,
    POClose_Model,
    userAccessList: state.Mini.userAccessList,
  };
};

export default connect(mapStatetoProps, {
  getPurchaseOrderList,
  GetWoAuthorizationStatus,
  SetParams,
  toggleItemMenu,
  listlayout,
  getPDFDownload,
  PurchaseOrderClose,
  PoFoucsPost,
  POClose_modal_open,
  POClose_modal_close,
  viewLogShowRightSidebarPurchase,
  ToggleEdit,
})(AllPurchaseOrder);
